export const TEST_LOCALISE_LANGUAGE_ARRAY = [
    ["English", "en_US"],
    ["Dutch", "de_DE"],
    ["Español", "es_ES"],
    ["Français", "fr_FR"],
    ["Português", "pt_BR"],
    ["Italian", "it_IT"],
    ["China", "zh_CN"],
    ["Japan", "ja_JP"],
    ["Poland", "pl_PL"],
];

export const LOCALISE_LANGUAGES = [
    {
        languageCode: "de_DE",
        languageName: "Deutsch",
        countryName: "Deutschland",
        class: "german-flag",
        image: "app/assets/image/german.svg",
        checked: false,
    },
    {
        languageCode: "en_AU",
        languageName: "English",
        countryName: "Australia",
        class: "australia-flag",
        image: "app/assets/image/australia.svg",
        checked: false,
    },
    {
        languageCode: "en_CA",
        languageName: "English",
        countryName: "Canada",
        class: "canada-flag",
        image: "app/assets/image/canada.svg",
        checked: false,
    },
    {
        languageCode: "en_GB",
        languageName: "English",
        countryName: "United Kingdom",
        class: "uk-flag",
        image: "app/assets/image/united-kingdom.svg",
        checked: false,
    },
    {
        languageCode: "en_US",
        languageName: "English",
        countryName: "United States",
        class: "us-flag",
        image: "app/assets/image/UK.svg",
        checked: false,
    },
    {
        languageCode: "es_AR",
        languageName: "Español",
        countryName: "Argentina",
        class: "argentina-flag",
        image: "app/assets/image/argentina.svg",
        checked: false,
    },
    {
        languageCode: "es_ES",
        languageName: "Español",
        countryName: "España",
        class: "espana-flag",
        image: "app/assets/image/spain.svg",
        checked: false,
    },
    {
        languageCode: "es_MX",
        languageName: "Español",
        countryName: "Mexico",
        class: "mexico-flag",
        image: "app/assets/image/mexico.svg",
        checked: false,
    },
    {
        languageCode: "fr_CA",
        languageName: "Français",
        countryName: "Canada",
        class: "canada-flag",
        image: "app/assets/image/canada.svg",
        checked: false,
    },
    {
        languageCode: "fr_FR",
        languageName: "Français",
        countryName: "France",
        class: "france-flag",
        image: "app/assets/image/french.svg",
        checked: false,
    },
    {
        languageCode: "it_IT",
        languageName: "Italian",
        countryName: "Italy",
        class: "italy-flag",
        image: "app/assets/image/italy.svg",
        checked: false,
    },
    {
        languageCode: "ja_JP",
        languageName: "日本",
        countryName: "Japan",
        class: "japan-flag",
        image: "app/assets/image/japan.svg",
        checked: false,
    },
    {
        languageCode: "pl_PL",
        languageName: "Polski",
        countryName: "Poland",
        class: "poland-flag",
        image: "app/assets/image/poland.svg",
        checked: false,
    },
    {
        languageCode: "pt_BR",
        languageName: "Português",
        countryName: "Brasil",
        class: "brasil-flag",
        image: "app/assets/image/brazil.svg",
        checked: false,
    },
    {
        languageCode: "pt_PT",
        languageName: "Português",
        countryName: "Portugal",
        class: "portugal-flag",
        image: "app/assets/image/portugal.svg",
        checked: false,
    },
    {
        languageCode: "zh_CN",
        languageName: "中国人",
        countryName: "China",
        class: "china-flag",
        image: "app/assets/image/china.svg",
        checked: false,
    },
];

export const DefaultLanguage = "en_US";
export const JAPAN_LANGUAGE_CODE = "ja_JP";
export const POLAND_LANGUAGE_CODE = "pl_PL";

export const UK_COUNTRY_CODE_NEW = "uk";
export const UK_COUNTRY_CODE_OLD = "gb";
export const UK_COUNTRY_DIALCODE = "44";

export const PREFERRED_COUNTRIES_LIST = ["us", "ca", "gb"];
